import React from "react";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { observer, inject } from "mobx-react";
import { FixedPanelItem } from "ComponentsUI/SideWidgets";
import CompareTariffsContainer from "Containers/compareTariffsContainer";
import FiltersWidgetContainer from "Containers/FiltersWidgetContainer";
import CallbackLogic from "HOC/CallbackLogic";
import CallbackFixedContainer from "Containers/CallbackFixedContainer";
import withStyles from "react-jss";
import Metrika from "Services/Metrika";
import { EVENT_ACTION_CLICK_WAIT_CALL } from "Constants/metriks/GoogleActions";
import { EVENT_CATEGORY_CALLBACK } from "Constants/metriks/GoogleCategorys";

const styles = theme => {
    return {
        root: {
            height: "auto",
            display: "flex",
            width: "auto",
            flexWrap: "wrap",
            position: "fixed",
            right: "50px",
            flexDirection: "column",
            bottom: "50px",
            transition: "bottom, right .3s ease",
            opacity: 1,
        },
        isHide: {
            right: "-100px !important",
        },
        fullyHide: {
            display: "none",
        },
        isShowCompare: {
            bottom: "140px",
        },
        [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
            root: {
                right: "30px",
                bottom: "30px",
            },
            isShowCompare: {
                bottom: "120px",
            },
        },
        [`@media (max-width: ${theme.media.sm})`]: {
            root: {
                right: "20px",
                bottom: "20px",
            },
            isShowCompare: {
                bottom: "100px",
            },
        },
    };
};

@inject("ApplicationModel")
@observer
class FixedPanel extends React.Component {
    constructor(props) {
        super(props);
    }

    sendOrder(data) {
        Metrika.getInstance().google.sendEvent(
            EVENT_CATEGORY_CALLBACK,
            EVENT_ACTION_CLICK_WAIT_CALL
        );
    }

    render() {
        let {
            ApplicationModel: {
                compareTarifficationsModel,
                commonViewModel,
                fixedPanelModel,
            },
        } = this.props;
        let region = this.props.ApplicationModel.currentRegion;
        let classes = this.props.classes;
        let showGiftWidget = fixedPanelModel.showGiftWidget;
        let showCallbackFixed = !this.props.ApplicationModel.__CONFIG_SITES
            .HIDE_FIXED_CALLBACK;
        return (
            <div
                className={classNames(classes.root, "fixed", {
                    [classes.isShowCompare]: compareTarifficationsModel.isOpen,
                    [classes.isHide]: !fixedPanelModel.fixedPanelIsVisible,
                    [classes.fullyHide]:
                        !!commonViewModel.showMobileMenu ||
                        !commonViewModel.visibleSideWidget ||
                        !region ||
                        !region?.id,
                })}
            >
                <FixedPanelItem noMargin={compareTarifficationsModel.isOpen}>
                    <CompareTariffsContainer />
                </FixedPanelItem>
                {fixedPanelModel.filtersWidgetIsVisible && (
                    <FixedPanelItem isHide={true}>
                        <FiltersWidgetContainer />
                    </FixedPanelItem>
                )}
                {true && (
                    <FixedPanelItem>
                        <CallbackLogic>
                            <CallbackFixedContainer
                                onSendOrder={data => this.sendOrder(data)}
                            />
                        </CallbackLogic>
                    </FixedPanelItem>
                )}
            </div>
        );
    }
}

export default withRouter(withStyles(styles)(FixedPanel));
